export default {"src":"/_next/static/media/American-Express.16a99b1f.svg","height":62,"width":62,"blurWidth":0,"blurHeight":0};